'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Heading } from '../../ui/heading';
import { Button } from '../../ui/button';
import { Paragraph } from '../../ui/paragraph';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProductDeliveryReturn() {
  const { t } = useTranslations();

  const data = [
    {
      icon: '/images/icons/truck-fast.svg',
      title: t('text3266'),
      description: t('text3267'),
      buttonLabel: t('text3268'),
    },
    {
      icon: '/images/icons/3d-rotate.svg',
      title: t('text3269'),
      description: t('text3270'),
      buttonLabel: t('text3271'),
    },
  ];

  return (
    <div className="flex w-full flex-col items-start justify-start gap-6 lg:gap-4">
      {data.map(item => (
        <div key={item.title} className="flex w-full items-start justify-start gap-3 sm:gap-4">
          <Image
            src={item.icon}
            alt={item.title}
            width={32}
            height={32}
            className="max-h-8 min-h-8 min-w-8 max-w-8"
          />
          <div className="flex w-full flex-col items-start justify-start gap-2">
            <div className="flex w-full flex-col items-start justify-start gap-1">
              <Heading tag="h2" title={item.title} className={{ title: 'h6' }} />
              <Paragraph size="sm" className="w-full max-w-[380px]">
                {item.description}
              </Paragraph>
            </div>
            <Button
              asChild
              variant={'none'}
              size={'none'}
              className={cn(
                'text-sm font-semibold text-primary underline transition-all hover:opacity-80',
                'custom-uppercase',
              )}
            >
              <Link prefetch={false} href={ROUTES.PAYMENT_OPTIONS()}>
                {item.buttonLabel}
              </Link>
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}
